import cn from 'classnames';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const BotonFormAtras = ({ type = 'button', onClick, state = 'hidde' }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={cn(
        'w-full relative py-10 px-26 rounded-full border border-solid border-[#ebebeb] cursor-pointer scale-0 duration-40 origin-center',
        {
          'scale-100': state === 'show'
        }
      )}
    >
      <div className="p1 for-button relative z-3 uppercase text-center">volver atrás</div>
    </button>
  );
};
export default BotonFormAtras;
